import useBindActionCreators from 'common/hooks/useBindActionCreators';

import { mapOperations } from '../store';

export const useMapOperations = (): typeof mapOperations => {
  const bindedActions = useBindActionCreators(mapOperations);
  return bindedActions;
};
